import { FC } from "react"
import Tooltip from "../shared/Tooltip"
import Button, { ButtonIconPosition } from "@/components/shared/Button"
import { PageRoutes } from "@/constants/routes"
import { useUserRole } from "@/hooks/useUserRole"
import { ButtonVariant } from "@/types/index"

type CellActionsProps = {
   noVitals?: boolean
   maintenance?: boolean
   hideButtons?: boolean
   onSetMaintenanceOff?: () => void
   onSetVacant?: () => void
   onViewDetails?: () => void
}

const CellActions: FC<CellActionsProps> = ({
   noVitals,
   maintenance,
   hideButtons,
   onSetMaintenanceOff = () => {},
   onSetVacant = () => {},
   onViewDetails = () => {},
}) => {
   const userCanAccessDetailView = useUserRole(PageRoutes.CELL_DETAIL_OVERVIEW)

   if (hideButtons) {
      return null
   }
   return (
      <span className="cell-card__buttons">
         {noVitals && (
            <Button
               className="cell-card__set-status-button"
               variant={ButtonVariant.SMALL}
               iconName="setVacant"
               iconSize="12"
               iconPosition={ButtonIconPosition.LEFT}
               onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  onSetVacant()
               }}
            >
               Vacate
            </Button>
         )}
         {maintenance && (
            <Button
               className="cell-card__set-status-button"
               variant={ButtonVariant.SMALL}
               iconName="sensor"
               iconSize="12"
               iconPosition={ButtonIconPosition.LEFT}
               onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  onSetMaintenanceOff()
               }}
            >
               Activate
            </Button>
         )}
         {userCanAccessDetailView && (
            <Tooltip content="Go to detail overview">
               <Button
                  className="cell-card__set-status-button"
                  variant={ButtonVariant.SMALL}
                  iconName="visual"
                  iconSize="12"
                  iconPosition={ButtonIconPosition.LEFT}
                  onClick={(e) => {
                     e.stopPropagation()
                     e.preventDefault()
                     onViewDetails()
                  }}
               />
            </Tooltip>
         )}
      </span>
   )
}

export default CellActions
